export const GetAdminRole = (user) => {
    if (user?.is_super_admin) return 'super_admin';
    if (user?.is_admin) return 'admin';
    if (user?.is_cs) return 'cs';
    return null; // atau "guest"
};